import React, {createRef, useContext} from "react";
import {useTranslation} from "react-i18next";
import {Fade, Slide} from "react-reveal";
import "./EducationCard.scss";
import StyleContext from "../../contexts/StyleContext";

export default function EducationCard({school, index}) {
  const {t} = useTranslation();
  const imgRef = createRef();

  // Get translated education data
  const getTranslatedSchool = () => {
    const schools = t("education.schools", {returnObjects: true});
    return schools[index] || {};
  };

  const translatedSchool = getTranslatedSchool();

  const GetDescBullets = ({descBullets}) => {
    return descBullets
      ? descBullets.map((item, i) => (
          <li key={i} className="subTitle">
            {item}
          </li>
        ))
      : null;
  };
  const {isDark} = useContext(StyleContext);

  if (!school.logo)
    console.error(
      `Image of ${
        translatedSchool.name || school.schoolName
      } is missing in education section`
    );
  return (
    <div>
      <Fade left duration={1000}>
        <div className="education-card">
          {school.logo && (
            <div className="education-card-left">
              <img
                crossOrigin={"anonymous"}
                ref={imgRef}
                className="education-roundedimg"
                src={school.logo}
                alt={translatedSchool.name || school.schoolName}
              />
            </div>
          )}
          <div className="education-card-right">
            <h5 className="education-text-school">
              {translatedSchool.name || school.schoolName}
            </h5>

            <div className="education-text-details">
              <h5
                className={
                  isDark
                    ? "dark-mode education-text-subHeader"
                    : "education-text-subHeader"
                }
              >
                {translatedSchool.degree || school.subHeader}
              </h5>
              <p
                className={`${
                  isDark ? "dark-mode" : ""
                } education-text-duration`}
              >
                {translatedSchool.duration || school.duration}
              </p>
              <p className="education-text-desc">
                {translatedSchool.desc || school.desc}
              </p>
              <div className="education-text-bullets">
                <ul>
                  <GetDescBullets
                    descBullets={translatedSchool.points || school.descBullets}
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Fade>
      <Slide left duration={2000}>
        <div className="education-card-border"></div>
      </Slide>
    </div>
  );
}
